import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

import './semantic/dist/semantic.min.css';
import './index.css';

import { App } from './containers';
import registerServiceWorker from './registerServiceWorker';

// import { store, startPersisting } from './store';
import storage from './store';

const { persistor, store } = storage();

// startPersisting();

ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <BrowserRouter>
        <Switch>
          <Route path="/" component={App} />
        </Switch>
      </BrowserRouter>
    </PersistGate>
  </Provider>,
  document.getElementById('root'),
);
registerServiceWorker();

// <Route path="/:ticker" component={App} />



// WEBPACK FOOTER //
// ./src/Routes.jsx